import { render, staticRenderFns } from "./Read-more.vue?vue&type=template&id=11e2d8cd&scoped=true"
import script from "./Read-more.vue?vue&type=script&lang=js"
export * from "./Read-more.vue?vue&type=script&lang=js"
import style0 from "./Read-more.vue?vue&type=style&index=0&id=11e2d8cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e2d8cd",
  null
  
)

export default component.exports